import { FunctionalComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { logger } from '@accedo/logger';
import { LoadingIndicator } from '##/components/LoadingIndicator/LoadingIndicator';
import { PageNavigation } from '##/utils/PageNavigation';
import { LiveCarouselItem } from '##/components/LiveCarousel/types';
import { StandardCarouselItem } from '##/components/StandardCarousel/types';
import { setNavVisibility } from './SideNav/SideNav';

const LoadingPage: FunctionalComponent<{}> = () => {
  useEffect(() => {
    logger.info('[LoadingPage] on mount...');
    setNavVisibility?.(false);

    const { nextRoute, tileData } = PageNavigation.getCurrentState() as {
      nextRoute: string;
      tileData: LiveCarouselItem | StandardCarouselItem;
    };

    if (nextRoute) {
      setTimeout(() => {
        logger.info('[LoadingPage] navigating to next route...');

        PageNavigation.replaceRoute(nextRoute, tileData);
      }, 2000);
    }

    () => {
      setNavVisibility?.(true);
    };
  }, []);
  return <LoadingIndicator customId="loading-page-indicator" />;
};

export default LoadingPage;
